import { CalendarHeart, Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HostYourStory() {
  return <section data-section-id="135383" id="kilig-sala-intimate-dining" className="bg-background text-foreground relative min-h-[85vh] flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/champagne_pour_slow_motion.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 z-10 bg-black/40" aria-hidden="true" />

      {}
      <div className="relative z-20 container mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-5xl">
        
        {}
        <h2 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-none tracking-tight mb-10 drop-shadow-lg">
          <span className="text-white block sm:inline">Private Dining Room </span>
          <span className="text-primary italic block sm:inline mt-2 sm:mt-0">for 10–15 Guests</span>
        </h2>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full sm:w-auto mt-4">
          <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-sm md:text-base tracking-[0.15em] uppercase rounded-xl shadow-xl hover:shadow-primary/20 transition-all duration-300 bg-primary text-primary-foreground" asChild>
            <Link to="/ConnectPage">
              <CalendarHeart className="mr-2 size-5" />
              Book via WhatsApp
            </Link>
          </Button>

          <Button variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-sm md:text-base tracking-[0.15em] uppercase rounded-xl border-white/50 bg-white/10 backdrop-blur-md hover:bg-white/30 hover:border-white text-white transition-all duration-300" asChild>
            <Link to="/PrivateDiningPage">
              <Download className="mr-2 size-5" />
              Fully Air-Conditioned
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}